define('SageDotCom/DataLayer/Events/supportProductSelection',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ButtonClickEvent() {
        EventBase.call(this); // inherit eventBase
        this.name = "support_product"; // overwrite name
    }

    ButtonClickEvent.prototype = Object.create(EventBase.prototype);

    ButtonClickEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label, product, businessSize) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "component",
            'event_action': "support product selection"
        }

        if (scope) {
            var lbl = label || $(scope).attr("data-title") || $(scope).text() || $("a:first", scope).text() || "";
            var location = this.getLocation(scope);

            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': businessSize,
                'event_name_level_3': this.cleanseString(product),
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new ButtonClickEvent();
});
